"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = exports.SiteType = exports.PageType = void 0;
var PageType;
(function (PageType) {
    PageType["ACCOUNT"] = "account_overview";
    PageType["ACCOUNT_AFTER_LOGIN"] = "account_overview_after_login";
    PageType["ACCOUNT_AFTER_REGISTRATION"] = "account_overview_after_registration";
    PageType["ACCOUNT_CHANGE_EMAIL"] = "changeEmail";
    PageType["ACCOUNT_CHANGE_PASSWORD"] = "change_passsword";
    PageType["ACCOUNT_COPAYMENT_REPORT"] = "account_copayment_report";
    PageType["ACCOUNT_NEWSLETTER"] = "account_newsletter";
    PageType["ACCOUNT_ORDER"] = "account_orders";
    PageType["ACCOUNT_ORDER_DETAILS"] = "account_orders_details";
    PageType["CART"] = "cart";
    PageType["CART_INTERMEDIATE"] = "cartintermediate";
    PageType["CHECKOUT_ADDRESS"] = "checkout_address";
    PageType["CHECKOUT_ADDRESS_AFTER_LOGIN"] = "checkout_address_after_login";
    PageType["CHECKOUT_ADDRESS_AFTER_REGISTRATION"] = "checkout_address_after_registration";
    PageType["CHECKOUT_CONFIRMATION"] = "checkout_confirmation";
    PageType["CHECKOUT_DELIVERY"] = "checkout_delivery";
    PageType["CHECKOUT_PAYMENT"] = "checkout_payment";
    PageType["CHECKOUT_VERIFICATION"] = "checkout_verification";
    PageType["DAMAGED_PRODUCTS"] = "damaged_products";
    PageType["PRODUCTS_CANCELLATION"] = "products_cancellation";
    PageType["DAMAGED_PRODUCTS_CONFIRMATION"] = "damaged_products_confirmation";
    PageType["DAMAGED_PRODUCTS_CUSTOMER_CARE"] = "damaged_products_customer_care";
    PageType["ERX_LANDING_PAGE"] = "erx_landing_page";
    PageType["HOME"] = "home";
    PageType["INTERACTIONS_RESULTS"] = "interactions_results";
    PageType["INTERACTIONS_SEARCH"] = "interactions_search";
    PageType["LEAFLET_SEARCH"] = "leaflet_search";
    PageType["LOGIN"] = "login";
    PageType["MARKETING"] = "marketing";
    PageType["MISSING_PRODUCTS"] = "missing_products";
    PageType["MISSING_PRODUCTS_CONFIRMATION"] = "missing_products_confirmation";
    PageType["PRODUCTS_CANCELLATION_CONFIRMATION"] = "products_cancellation_confirmation";
    PageType["MISSING_PRODUCTS_CUSTOMER_CARE"] = "missing_products_customer_care";
    PageType["PRODUCTS_CANCELLATION_CUSTOMER_CARE"] = "products_cancellation_customer_care";
    PageType["NEWSLETTER"] = "newsletter";
    PageType["NEWSLETTER_UNSUBSCRIBE"] = "newsletter_unsubscribe";
    PageType["NEWSLETTER_CONFIRMATION"] = "newsletter_confirmation";
    PageType["NFC_LANDING_PAGE"] = "nfc_landing_page";
    PageType["OFFER"] = "offer";
    PageType["PDP"] = "pdp";
    PageType["PDP_AFTER_LOGIN"] = "pdp_after_login";
    PageType["PDP_AFTER_REGISTRATION"] = "pdp_after_registration";
    PageType["RX_LANDING_PAGE"] = "rx_landing_page";
    PageType["SEARCH_RESULTS"] = "search";
    PageType["BRANDS"] = "brands";
})(PageType || (exports.PageType = PageType = {}));
/**
 * siteType
 */
var SiteType;
(function (SiteType) {
    SiteType["ACCOUNT"] = "account_overview";
    SiteType["ACCOUNT_AFTER_LOGIN"] = "account_overview";
    SiteType["ACCOUNT_AFTER_REGISTRATION"] = "account_overview";
    SiteType["ACCOUNT_CHANGE_EMAIL"] = "changeEmail";
    SiteType["ACCOUNT_CHANGE_PASSWORD"] = "change_password";
    SiteType["ACCOUNT_COPAYMENT_REPORT"] = "account_copayment_report";
    SiteType["ACCOUNT_NEWSLETTER"] = "newsletter";
    SiteType["ACCOUNT_ORDER"] = "account_orders";
    SiteType["ACCOUNT_ORDER_DETAILS"] = "account_orders";
    SiteType["CART"] = "cart";
    SiteType["CART_INTERMEDIATE"] = "add_to_cart";
    SiteType["CHECKOUT_ADDRESS"] = "checkout_address";
    SiteType["CHECKOUT_ADDRESS_AFTER_LOGIN"] = "checkout_address";
    SiteType["CHECKOUT_ADDRESS_AFTER_REGISTRATION"] = "checkout_address";
    SiteType["CHECKOUT_CONFIRMATION"] = "checkout_confirmation";
    SiteType["CHECKOUT_DELIVERY"] = "checkout_address";
    SiteType["CHECKOUT_PAYMENT"] = "checkout_payment";
    SiteType["CHECKOUT_VERIFICATION"] = "checkout_verification";
    SiteType["ERX_LANDING_PAGE"] = "eRx";
    SiteType["HOME"] = "home";
    SiteType["INTERACTIONS_RESULTS"] = "interactioncheck";
    SiteType["INTERACTIONS_SEARCH"] = "interactioncheck";
    SiteType["LEAFLET_SEARCH"] = "leaflets";
    SiteType["LOGIN"] = "login";
    SiteType["MARKETING"] = "marketing";
    SiteType["NEWSLETTER"] = "newsletter";
    SiteType["NEWSLETTER_UNSUBSCRIBE"] = "newsletter";
    SiteType["NEWSLETTER_CONFIRMATION"] = "newsletter";
    SiteType["NFC_LANDING_PAGE"] = "eRx";
    SiteType["OFFER"] = "offer";
    SiteType["PDP"] = "product";
    SiteType["PDP_AFTER_LOGIN"] = "product";
    SiteType["PDP_AFTER_REGISTRATION"] = "product";
    SiteType["RX_LANDING_PAGE"] = "rx_landing_page";
    SiteType["SEARCH_RESULTS"] = "search";
    SiteType["BRANDS"] = "brands";
})(SiteType || (exports.SiteType = SiteType = {}));
/**
 * contentType
 */
var ContentType;
(function (ContentType) {
    ContentType["ACCOUNT"] = "Mein Konto/Ihre \u00DCbersicht";
    ContentType["ACCOUNT_AFTER_LOGIN"] = "Mein Konto/Ihre \u00DCbersicht";
    ContentType["ACCOUNT_AFTER_REGISTRATION"] = "Mein Konto/Ihre \u00DCbersicht";
    ContentType["ACCOUNT_CHANGE_EMAIL"] = "Mein Konto/E-Mail-Adresse \u00E4ndern";
    ContentType["ACCOUNT_CHANGE_PASSWORD"] = "Mein Konto/Passwort \u00E4ndern";
    ContentType["ACCOUNT_COPAYMENT_DOCUMENT"] = "Account/Copayment/Document";
    ContentType["ACCOUNT_COPAYMENT_REPORT_INSURANCE_EMPTY"] = "Account/Copayment/Insurance_Empty";
    ContentType["ACCOUNT_COPAYMENT_REPORT_INSURANCE_FILLED"] = "Account/Copayment/Insurance_Filled";
    ContentType["ACCOUNT_COPAYMENT_REPORT_TAX_EMPTY"] = "Account/Copayment/Tax_Empty";
    ContentType["ACCOUNT_COPAYMENT_REPORT_TAX_FILLED"] = "Account/Copayment/Tax_Filled";
    ContentType["ACCOUNT_NEWSLETTER"] = "Account Newsletter/Ihr pers\u00F6nlicher Newsletter";
    ContentType["ACCOUNT_ORDER"] = "Mein Konto/Bestellhistorie";
    ContentType["ACCOUNT_ORDER_DETAILS"] = "Mein Konto/Bestellhistorie Details";
    ContentType["CART"] = "Mein Warenkorb";
    ContentType["CART_INTERMEDIATE"] = "Produkt in den Warenkorb gelegt";
    ContentType["CHECKOUT_ADDRESS"] = "Rechnungsadresse";
    ContentType["CHECKOUT_ADDRESS_AFTER_LOGIN"] = "Rechnungsadresse";
    ContentType["CHECKOUT_ADDRESS_AFTER_REGISTRATION"] = "Rechnungsadresse";
    ContentType["CHECKOUT_CONFIRMATION"] = "Bestellung abgeschlossen";
    ContentType["CHECKOUT_DELIVERY"] = "Lieferadresse";
    ContentType["CHECKOUT_PAYMENT"] = "Zahlarten";
    ContentType["CHECKOUT_VERIFICATION"] = "Bestellung Kontrollieren";
    ContentType["ERX_LANDING_PAGE"] = "eRx/Landingpage";
    ContentType["HOME"] = "Startseite";
    ContentType["INTERACTIONS_RESULTS"] = "Interactioncheck/results";
    ContentType["INTERACTIONS_SEARCH"] = "Interactioncheck/main";
    ContentType["LEAFLET_SEARCH"] = "Leaflets/main";
    ContentType["LOGIN"] = "Anmeldung";
    ContentType["MARKETING"] = "Marketing";
    ContentType["NEWSLETTER"] = "Newsletter/Ihr pers\u00F6nlicher Newsletter";
    ContentType["NEWSLETTER_UNSUBSCRIBE"] = "Newsletter Abmeldung";
    ContentType["NEWSLETTER_CONFIRMATION"] = "Newsletter Confirmation";
    ContentType["NFC_LANDING_PAGE"] = "eRx/NFC-Landingpage";
    ContentType["OFFER"] = "Offerseite";
    ContentType["PDP"] = "Produktdetailseite";
    ContentType["PDP_AFTER_LOGIN"] = "Produktdetailseite";
    ContentType["PDP_AFTER_REGISTRATION"] = "Produktdetailseite";
    ContentType["RX_LANDING_PAGE"] = "Rx/Redemption";
    ContentType["SEARCH_RESULTS"] = "Suchseite";
    ContentType["BRANDS"] = "Marken";
})(ContentType || (exports.ContentType = ContentType = {}));
//# sourceMappingURL=enums.js.map